export default {
  root: {
    boxShadow: 'none',
    // border: 0,
    '&$expanded': {
      margin: 0,
    },
  },
};
